<template>
  <iframe
    id="ifr"
    src="/Elsa.html"
    sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
  />
</template>

<script>

export default {
  name: 'ElsaWorkflow',
  components: {},
  mounted() {
    // Get current host localStorage and write into ELSA's localStorage
    let data = {};
    Object.keys(localStorage).forEach(key => {
      data = {...data, [key]: localStorage.getItem(key)};
    });

    setTimeout(() => {
      const win = document.getElementById('ifr').contentWindow;
      win.postMessage({
        localStorage: data,
        apiDomain: window.VUE_APP_NODE_SERVER_URL,
      }, '/Elsa.html');
    }, 500);
  },
};
</script>

<style scoped>
#ifr {
  height: 100%;
  border: unset;
}
</style>
